ko.bindingHandlers.showToolTip = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        $(element).qtip({
            content: ko.utils.unwrapObservable(valueAccessor()),
            position: {
                my: 'bottom left',
                target: 'mouse',
                viewport: $(window),
                adjust: {
                    x: 5, y: 0
                }
            },
            show: {
                delay: 500,
                effect: function () { $(this).fadeIn(250); }
            },
            hide: {
                fixed: true,
                effect: function () { $(this).fadeOut(250); }
            },
            style: 'ui-tooltip-shadow' + ($(element).hasClass('toolTipLink-wide') ? ' ui-tooltip-wide' : '')
        });
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
    }
};

ko.bindingHandlers.slideAway = {
    init: function (element, valueAccessor) {
        ko.utils.unwrapObservable(valueAccessor()) ? $(element).slideUp("slow") : $(element).slideDown("slow");
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        ko.utils.unwrapObservable(valueAccessor()) ? $(element).slideUp("slow") : $(element).slideDown("slow");
    }
};

ko.bindingHandlers.watermark = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var value = valueAccessor();
        var defaultWatermark = ko.utils.unwrapObservable(value);

        setTimeout(function () {
            if ($(element).val() == "") {
                $(element).val(defaultWatermark);
                $(element).removeClass('focused');
            }
            else {
                $(element).addClass('focused');
            }
        }, 0);

        $(element).focus(
            function () {
                if ($(element).val() == defaultWatermark) {
                    $(element).val("");
                    $(element).addClass('focused');
                }
            }).blur(function () {
                if ($(element).val() == "") {
                    $(element).val(defaultWatermark)
                    $(element).removeClass('focused');
                }
            });
    },
    update: function (element, valueAccessor) {
    }
};

ko.bindingHandlers.fadeVisible = {
    init: function (element, valueAccessor) {
        // Initially set the element to be instantly visible/hidden depending on the value
        setTimeout(function () {
            $(element).toggle(ko.utils.unwrapObservable(valueAccessor()));
        }, 0);
    },
    update: function (element, valueAccessor) {
        // Whenever the value subsequently changes, slowly fade the element in or out
        var value = valueAccessor();
        ko.utils.unwrapObservable(value) ? $(element).fadeIn("slow") : $(element).fadeOut("slow");
    }
};

ko.bindingHandlers.slideVisible = {
    init: function (element, valueAccessor) {
        // Initially set the element to be instantly visible/hidden depending on the value
        setTimeout(function () {
            if (ko.utils.unwrapObservable(valueAccessor())) {
                $(element).show();
            } else {
                $(element).hide();
            }           
        }, 0);
    },
    update: function (element, valueAccessor) {
        // Whenever the value subsequently changes, slowly fade the element in or out
        var value = valueAccessor();
        var isVisible = ko.utils.unwrapObservable(value);
        isVisible ? $(element).slideDown() : $(element).slideUp();
    }
};

ko.bindingHandlers.cssOnHover = {
    update: function (element, valueAccessor) {
        ko.utils.registerEventHandler(element, "mouseover", function () {
            $(element).addClass(ko.utils.unwrapObservable(valueAccessor()));
        });

        ko.utils.registerEventHandler(element, "mouseleave", function () {
            $(element).removeClass(ko.utils.unwrapObservable(valueAccessor()));
        });
    }
};

ko.bindingHandlers.datepicker = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        $(element).datepicker({
            dateFormat: ko.utils.unwrapObservable(valueAccessor())
        });
    },
    update: function (element, valueAccessor) {
    }
};

ko.bindingHandlers.customKendoChart = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var params = valueAccessor();
        $(element).kendoChart({
            theme: $(document).data("kendoSkin") || "default",
            title: {
                visible: false,
                text: params.chartTitle
            },
            legend: {
                visible: false,
                position: params.chartLegendPosition || "top"
            },
            dataSource: {
                data: ko.toJS(params.chartData)
            },
            series: [{
                type: params.chartType || "pie",
                field: params.chartValue,
                categoryField: params.chartHead,
                overlay: {
                    gradient: "none"
                }
            }],
            seriesDefaults: {
                labels: {
                    visible: params.chartHint ? true : false,
                    template: params.chartHint || ""
                }
            },
            tooltip: {
                visible: false,
                template: "${ category } - ${ value }%"
            }
        });
    },
    update: function (element, valueAccessor) {
    }
};

ko.bindingHandlers.autoResizeInput = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var params = valueAccessor(),
            min = parseInt(params.min) || 25 ,
            max = parseInt(params.max) || 300 ,
            pad_right = parseInt(params.paddingRight) || 10, 
            input = element;

        input.style.width = min + 'px';
        input.onkeypress = input.onkeydown = input.onkeyup = function () {
            var input = this;
            setTimeout(function () {
                var tmp = document.createElement('div');
                tmp.style.padding = '0';
                if (getComputedStyle)
                    tmp.style.cssText = getComputedStyle(input, null).cssText;
                if (input.currentStyle)
                    tmp.style.cssText = input.currentStyle.cssText;
                tmp.style.width = '';
                tmp.style.position = 'absolute';
                tmp.innerHTML = input.value.replace(/&/g, "&amp;")
                                       .replace(/</g, "&lt;")
                                       .replace(/>/g, "&gt;")
                                       .replace(/"/g, "&quot;")
                                       .replace(/'/g, "&#039;")
                                       .replace(/ /g, '&nbsp;');
                input.parentNode.appendChild(tmp);
                var width = tmp.clientWidth + pad_right + 1;
                tmp.parentNode.removeChild(tmp);
                if (min <= width && width <= max)
                    input.style.width = width + 'px';
            }, 1);
        }
    },
    update: function (element, valueAccessor) {
    }
};

ko.bindingHandlers.if_fade = {
    init: function (element) {
        $(ko.virtualElements.childNodes(element))
            .filter(function () { return this.nodeType == 1; })
            .hide()
            .fadeIn("slow");
    }
};
ko.virtualElements.allowedBindings.if_fade = true;

ko.bindingHandlers.highlightedText = {
    update: function (element, valueAccessor) {
        var options = valueAccessor();
        var value = ko.utils.unwrapObservable(options.text);
        var search = ko.utils.unwrapObservable(options.highlight);
        var css = ko.utils.unwrapObservable(options.css);
        if (options.sanitize) {
            value = $('<div/>').text(value).html();
        }
        var replacement = '<span class="' + css + '">' + search + '</span>';
        element.innerHTML = value.replace(new RegExp(search, 'gi'), replacement);
    }
};

ko.bindingHandlers.enterkey = {
    init: function(element, valueAccessor, allBindingsAccessor, viewModel) {
        var inputSelector = 'input,textarea,select';
        $(document).on('keypress', inputSelector, function(e) {
            var allBindings = allBindingsAccessor();
            $(element).on('keypress', 'input, textarea, select', function(e) {
                var keyCode = e.which || e.keyCode;
                if (keyCode !== 13) {
                    return true;
                }

                var target = e.target;
                target.blur();

                allBindings.enterkey.call(viewModel, viewModel, target, element);

                return false;
            });
        });
    }
};



//CULTURE
ko.extenders.numeric = function (target, options) {
    var precision = options.precision || (options === parseInt(options, 10) ? options : 2);
    var decimalSeparator = options.separator || '.';

    var result = ko.computed({
        read: function () {
            var ret = target();
            ret = ret.toFixed(precision);
            ret = ret.toString().replace('.', decimalSeparator);
            return ret;
        },
        write: target
    });

    result.raw = target;
    return result;
}

ko.bindingHandlers.el = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var value = valueAccessor();
        //assign value to observable (we specified in html)
        value(element);
    }
};

ko.bindingHandlers.$el = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var value = valueAccessor();
        //here we first create a jQuery object by using $(myelem)
        //before updating observable value
        value($(element).first());
    }
};